export enum DisputeStatus {
  OPEN = "open",
  UNDER_REVIEW = "under_review",
  RESOLVED_REFUND = "resolved_refund",
  RESOLVED_RELEASE = "resolved_release",
}
